import script from "./AntragfragenView.vue?vue&type=script&setup=true&lang=js"
export * from "./AntragfragenView.vue?vue&type=script&setup=true&lang=js"

import "./AntragfragenView.vue?vue&type=style&index=0&id=2dc93b4f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2dc93b4f"]])

export default __exports__